export const GET_PRICES_LANDING = 'GET_PRICES_LANDING';
export const GET_PRICES_COMPARES = 'GET_PRICES_COMPARES';

export interface FormFilters {
  wineId: number | undefined;
  vintage: string | undefined;
  format: string | undefined;
}

export interface WineOption {
  id: number;
  name: string;
}

export interface OptionsFilters {
  wines: WineOption[];
  vintages: string[];
  formats: string[];
}
